import { IPromise, IQService } from 'angular';
import { ISelectedItem } from '../../../shared/components/gmc-select/interfaces';

export class CurrencyService {
  static $inject = [ '$q' ];

  currencyList: string[] = [
    'USD',
    'EUR',
    'GBP',
    'Other...'
  ];

  constructor( private $q: IQService ) {
  }

  public getCurrencyList(): IPromise<ISelectedItem[]> {
    return null;
  }
}



// WEBPACK FOOTER //
// ./app/core/services/currency/currency.service.ts